import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=5890066e&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=5890066e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5890066e",
  null
  
)

export default component.exports